import React__default from 'react';
import { ChartGradientColor } from './types.js';
import { useChartColor } from './ZigChart/util.js';

var ThemeChartGradients = function () {
    var chart = useChartColor();
    return (React__default.createElement("svg", { style: { width: 0, height: 0, display: "block" } },
        React__default.createElement("defs", null,
            React__default.createElement("linearGradient", { id: ChartGradientColor.RedMini, x1: "1%", y1: "100%", x2: "0%", y2: "0%" },
                React__default.createElement("stop", { offset: "0%", stopColor: chart.redMiniGradient[0] }),
                React__default.createElement("stop", { offset: "50%", stopColor: chart.redMiniGradient[1] }),
                React__default.createElement("stop", { offset: "100%", stopColor: chart.redMiniGradient[2] })),
            React__default.createElement("linearGradient", { id: ChartGradientColor.GreenMini, x1: "1%", y1: "100%", x2: "0%", y2: "0%" },
                React__default.createElement("stop", { offset: "0%", stopColor: chart.greenMiniGradient[0] }),
                React__default.createElement("stop", { offset: "50%", stopColor: chart.greenMiniGradient[1] }),
                React__default.createElement("stop", { offset: "100%", stopColor: chart.greenMiniGradient[2] })),
            React__default.createElement("linearGradient", { id: ChartGradientColor.RedFull, x1: "0", y1: "1", x2: "0", y2: "0" },
                React__default.createElement("stop", { offset: "0%", stopColor: chart.redGradient[0] }),
                React__default.createElement("stop", { offset: "100%", stopColor: chart.redGradient[1] })),
            React__default.createElement("linearGradient", { id: ChartGradientColor.GreenFull, x1: "0", y1: "1", x2: "0", y2: "0" },
                React__default.createElement("stop", { offset: "0%", stopColor: chart.greenGradient[0] }),
                React__default.createElement("stop", { offset: "100%", stopColor: chart.greenGradient[1] })))));
};

export { ThemeChartGradients as default };
